import {createAsyncReducer} from '../../standard-actions/reducers'
import {
  IPutServiceReferenceAction,
  IPutServiceReferenceSuccessAction,
  IPutServiceReferenceErrorAction,
} from '../actions/put-service-reference'
import {IServicePerformanceState} from '../state'
import {initialState} from '../state/initial-state'

export type PutServiceReferenceAction =
  | IPutServiceReferenceAction
  | IPutServiceReferenceSuccessAction
  | IPutServiceReferenceErrorAction
const init = (state: IServicePerformanceState, action: PutServiceReferenceAction) => ({
  ...state,
  putServiceReference: {
    ...initialState.putServiceReference,
    status: action.status,
  },
})
const success = (state: IServicePerformanceState, action: PutServiceReferenceAction) => {
  return {
    ...state,
    putServiceReference: {
      ...initialState.putServiceReference,
      status: action.status,
    },
  }
}
const failure = (state: IServicePerformanceState, action: PutServiceReferenceAction) => ({
  ...state,
  putServiceReference: {
    ...initialState.putServiceReference,
    status: action.status,
    error: (action as IPutServiceReferenceErrorAction).error,
  },
})
export const putServiceReferenceReducer = createAsyncReducer(initialState, init, success, failure)
